const p={path:"/api/v1/apps/:app_id/smart_wallets",method:"GET"},a={path:"/api/v1/apps/:app_id/smart_wallets",method:"POST"};export{p as GetSmartWalletConfig,a as PostSmartWalletConfig};
